const minute = 60 * 1000
const hour = 60 * minute
const day = 24 * hour
const week = 7 * day
const month = 30 * day
const year = 365 * day

/**
 * Formats a comment timestamp as a deterministic, floor-based relative age.
 * Future timestamps are clamped to zero to avoid displaying negative ages
 * when client and server clocks differ slightly.
 */
export function formatCommentAge(
  createdDate: Date | string,
  now: Date
): string {
  const elapsed = Math.max(0, now.getTime() - new Date(createdDate).getTime())
  let value: number
  let unit: string

  if (elapsed < hour) {
    value = Math.floor(elapsed / minute)
    unit = 'minute'
  } else if (elapsed < day) {
    value = Math.floor(elapsed / hour)
    unit = 'hour'
  } else if (elapsed < week) {
    value = Math.floor(elapsed / day)
    unit = 'day'
  } else if (elapsed < month) {
    value = Math.floor(elapsed / week)
    unit = 'week'
  } else if (elapsed < year) {
    value = Math.floor(elapsed / month)
    unit = 'month'
  } else {
    value = Math.floor(elapsed / year)
    unit = 'year'
  }

  return `${value} ${unit}${value === 1 ? '' : 's'} ago`
}
